<template>
  <div class="total-table-container">
    <!-- 费率输入部分 -->
    <div class="rates-section">
      <div class="rate-item">
        <label for="basicReserveRate">基本预备费率：</label>
        <input
          type="number"
          id="basicReserveRate"
          v-model.number="totalInvestment.基本预备费率"
          placeholder="请输入基本预备费率"
          min="0"
          step="0.01"
          @input="handleRateInput"
        />
        <span class="rate-unit">%</span>
      </div>
      <div class="rate-item">
        <label for="inflationReserveRate">涨价预备费率：</label>
        <input
          type="number"
          id="inflationReserveRate"
          v-model.number="totalInvestment.涨价预备费率"
          placeholder="请输入涨价预备费率"
          min="0"
          step="0.01"
          @input="handleRateInput"
        />
        <span class="rate-unit">%</span>
      </div>
    </div>

    <!-- 投资估算表格 -->
    <div class="table-container">
      <table class="investment-table">
        <thead>
          <tr>
            <th>序号</th>
            <th>工程或费用名称</th>
            <th>建筑工程费</th>
            <th>设备购置费</th>
            <th>安装工程费</th>
            <th>其他费用</th>
            <th>合计</th>
            <th>比例(%)</th>
          </tr>
        </thead>
        <tbody
          v-if="totalInvestment && Object.keys(totalInvestment).length > 0"
        >
          <!-- 建设投资 -->
          <tr class="main-row">
            <td class="index-column">一</td>
            <td class="name-column">建设投资</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.建设投资?.合计) }}
            </td>
            <td class="number-column">
              {{ formatPercent(totalInvestment.建设投资?.比例 * 100) }}
            </td>
          </tr>

          <!-- 工程费用 -->
          <tr class="sub-row">
            <td class="index-column">1</td>
            <td class="name-column">工程费用</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.工程费用?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.工程费用?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.工程费用?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.工程费用?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.建设投资?.工程费用?.合计) }}
            </td>
            <td class="number-column">
              {{
                formatPercent(totalInvestment.建设投资?.工程费用?.比例 * 100)
              }}
            </td>
          </tr>

          <!-- 工程建设其他费用 -->
          <tr class="sub-row">
            <td class="index-column">2</td>
            <td class="name-column">工程建设其他费用</td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.工程建设其他费用?.建筑费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.工程建设其他费用?.设备费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.工程建设其他费用?.安装费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.工程建设其他费用?.其他费用
                )
              }}
            </td>
            <td class="number-column total-column">
              {{
                formatNumber(totalInvestment.建设投资?.工程建设其他费用?.合计)
              }}
            </td>
            <td class="number-column">
              {{
                formatPercent(
                  totalInvestment.建设投资?.工程建设其他费用?.比例 * 100
                )
              }}
            </td>
          </tr>

          <!-- 预备费 -->
          <tr class="sub-row">
            <td class="index-column">3</td>
            <td class="name-column">预备费</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.预备费?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.预备费?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.预备费?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设投资?.预备费?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.建设投资?.预备费?.合计) }}
            </td>
            <td class="number-column">
              {{ formatPercent(totalInvestment.建设投资?.预备费?.比例 * 100) }}
            </td>
          </tr>

          <!-- 基本预备费 -->
          <tr class="grandsub-row">
            <td class="index-column">3.1</td>
            <td class="name-column">基本预备费</td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.基本预备费?.建筑费用
                )
              }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.预备费?.基本预备费?.设备费用) }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.基本预备费?.安装费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.基本预备费?.其他费用
                )
              }}
            </td>
            <td class="number-column total-column">
              {{
                formatNumber(totalInvestment.建设投资?.预备费?.基本预备费?.合计)
              }}
            </td>
            <td class="number-column">
              {{
                formatPercent(
                  totalInvestment.建设投资?.预备费?.基本预备费?.比例 * 100
                )
              }}
            </td>
          </tr>

          <!-- 涨价预备费 -->
          <tr class="grandsub-row">
            <td class="index-column">3.2</td>
            <td class="name-column">涨价预备费</td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.涨价预备费?.建筑费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.涨价预备费?.设备费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.涨价预备费?.安装费用
                )
              }}
            </td>
            <td class="number-column">
              {{
                formatNumber(
                  totalInvestment.建设投资?.预备费?.涨价预备费?.其他费用
                )
              }}
            </td>
            <td class="number-column total-column">
              {{
                formatNumber(totalInvestment.建设投资?.预备费?.涨价预备费?.合计)
              }}
            </td>
            <td class="number-column">
              {{
                formatPercent(
                  totalInvestment.建设投资?.预备费?.涨价预备费?.比例 * 100
                )
              }}
            </td>
          </tr>

          <!-- 流动资金 -->
          <tr class="main-row">
            <td class="index-column">二</td>
            <td class="name-column">流动资金</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.流动资金?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.流动资金?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.流动资金?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.流动资金?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.流动资金?.合计) }}
            </td>
            <td class="number-column">
              {{ formatPercent(totalInvestment.流动资金?.比例 * 100) }}
            </td>
          </tr>

          <!-- 建设期利息 -->
          <tr class="main-row">
            <td class="index-column">三</td>
            <td class="name-column">建设期利息</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设期利息?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设期利息?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设期利息?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.建设期利息?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.建设期利息?.合计) }}
            </td>
            <td class="number-column">
              {{ formatPercent(totalInvestment.建设期利息?.比例 * 100) }}
            </td>
          </tr>

          <!-- 总投资 -->
          <tr class="main-row">
            <td class="index-column">四</td>
            <td class="name-column">总投资</td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.总投资?.建筑费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.总投资?.设备费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.总投资?.安装费用) }}
            </td>
            <td class="number-column">
              {{ formatNumber(totalInvestment.总投资?.其他费用) }}
            </td>
            <td class="number-column total-column">
              {{ formatNumber(totalInvestment.总投资?.合计) }}
            </td>
            <td class="number-column">
              {{ formatPercent(totalInvestment.总投资?.比例 * 100) }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td :colspan="8" style="text-align: center; padding: 20px">
              数据加载中...
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
//引入comp.js
import { totalTable } from "@/utils/comp.js";

export default {
  name: "TotalTable",
  data() {
    return {
      totalInvestment: {},
      projectData: {},
    };
  },
  computed: {
    projectDataFromStore() {
      return this.$store.state.projectData || {};
    },
  },
  watch: {
    // 监听项目数据变化
    projectDataFromStore: {
      handler() {
        this.loadFromVuex();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.loadFromVuex();
  },
  methods: {
    handleRateInput(event) {
      setTimeout(() => {
        // this.totalInvestment.基本预备费率 = event.target.value;
        this.saveToVuex();
      }, 500);
    },
    loadFromVuex() {
      console.log("=== loadFromVuex 触发 ===");
      this.projectData = this.$store.state.projectData || {};
      this.totalInvestment =
        this.$store.state.projectData?.["总投资估算"]?.["总表"] || {};
    },

    async saveToVuex() {
      this.projectData["总投资估算"]["总表"] = this.totalInvestment;
      this.$store.commit("SET_PROJECT_DATA", this.projectData);
      // 重新计算总投资估算
      this.$nextTick(() => {
        totalTable();
      });

      //
    },

    // 数字格式化
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "";
      if (num === 0) return "";
      return Number(num)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 百分比格式化
    formatPercent(num) {
      if (num === null || num === undefined || isNaN(num)) return "0%";
      if (num === 0) return "0%";
      return Number(num).toFixed(2) + "%";
    },
  },
};
</script>

<style scoped>
.total-table-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.rates-section {
  padding: 15px 20px;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.rate-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rate-item label {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  white-space: nowrap;
}

.rate-item input {
  width: 100px;
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s;
  text-align: right;
}

.rate-item input:focus {
  border-color: #409eff;
}

.rate-unit {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.table-container {
  flex: 1;
  overflow: auto;
  padding: 0 20px 20px 20px;
}

.investment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}

.investment-table th,
.investment-table td {
  border: 1px solid #dfe6ec;
  padding: 8px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.investment-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  color: #303133;
  position: sticky;
  top: 0;
  z-index: 10;
}

.name-column {
  width: 200px;
  min-width: 200px;
  text-align: left !important;
}

.index-column {
  width: 60px;
  min-width: 60px;
}

.number-column {
  width: 100px;
  min-width: 100px;
}

.total-column {
  font-weight: 600;
  background: #f0f9eb;
}

.main-row {
  background: #e8f4f8;
  font-weight: 600;
}

.main-row:hover {
  background: #d9ecff;
}

.sub-row {
  background: #f0f8ff;
}

.sub-row:hover {
  background: #e1f3d8;
}

.grandsub-row {
  background: #fafafa;
}

.grandsub-row:hover {
  background: #f5f7fa;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .rates-section {
    gap: 20px;
  }

  .rate-item input {
    width: 80px;
  }
}

@media (max-width: 768px) {
  .rates-section {
    flex-direction: column;
    gap: 15px;
  }

  .rate-item {
    justify-content: space-between;
  }

  .investment-table {
    font-size: 11px;
  }

  .investment-table th,
  .investment-table td {
    padding: 4px;
  }
}
</style>
